import React from 'react';
import ButtonApi from '../../components/ButtonApi';
import './ReferralCodeSection.scss';

const ReferralCodeSection = ({ referralCode, isLoading, referralStats, copyReferralLink }) => {
  // Show login message if no referral code is available (either not logged in or API failed)
  const hasReferralCode = referralCode && referralCode.trim() !== '';
  console.log("hasrefffff",hasReferralCode)
  return (
    <div className='referral-code-section'>
      <div className='referral-code-container'>
        {!hasReferralCode ? (
          // Show login message when no referral code is available
          <div className='login-required'>
            <div className='login-icon'>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M11 7L9.6 8.4L12.2 11H2V13H12.2L9.6 15.6L11 17L16 12L11 7ZM20 19H12V21H20C21.1 21 22 20.1 22 19V5C22 3.9 21.1 3 20 3H12V5H20V19Z" fill="#C9F032"/>
              </svg>
            </div>
            <div className='login-content'>
              <h3>Login Required</h3>
              <p>Login to get your referral code and start earning XP!</p>
            </div>
          </div>
        ) : (
          <>
            <div className='referral-code-display'>
              <div className='code-box'>
                <div className='code-label'>Referral Code</div>
                <div className='code-value'>
                  {isLoading ? (
                    <div className='loading-spinner'>
                      <div className='spinner'></div>
                      <span>Loading...</span>
                    </div>
                  ) : (
                    <span className='code-text'>
                      {referralCode}
                    </span>
                  )}
                </div>
              </div>
              <ButtonApi 
                className='copy-button' 
                onClick={copyReferralLink}
                disabled={!referralCode || isLoading}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M16 1H4C3 1 2 2 2 3V17H4V3H16V1ZM19 5H8C7 5 6 6 6 7V21C6 22 7 23 8 23H19C20 23 21 22 21 21V7C21 6 20 5 19 5ZM19 21H8V7H19V21Z" fill="currentColor"/>
                </svg>
                Copy Link
              </ButtonApi>
            </div>
            
            <div className='referral-stats'>
              <div className='stat-card'>
              
                <div className='stat-content'>
                  <span className='stat-number'>{referralStats.successfulInvites}</span>
                  <span className='stat-label'>Successful Invites</span>
                </div>
              </div>
            </div>
            
            <div className='referral-info'>
              <div className='info-icon'>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V13H11V7H13V13Z" fill="rgba(255,255,255,0.7)"/>
                </svg>
              </div>
              <p>
                A invite is only accounted successful when the referred person completes any 1 task and gain XP on their XION Identity.
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ReferralCodeSection; 